// FontAwesome with tree-shake ability - add only the icons we need for the project
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Import icons from pro-regular, pro-light, and pro-solid
import {
  faUser as faUserRegular,
  faMapMarkerAlt as faMapMarkerAltRegular,
  faCheck as faCheckRegular,
  faTimes as faTimesRegular,
  faSearch as faSearchRegular,
  faHeart as faHeartRegular,
  faCheckCircle as faCheckCircleRegular,
  faPhone as faPhoneRegular,
  faEnvelope as faEnvelopeRegular,
  faClock as faClockRegular,
  faTicket as faTicketRegular,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareRegular,
  faArrowRightToBracket as faArrowRightToBracketRegular,
  faArrowRight as faArrowRightRegular,
  faArrowLeft as faArrowLeftRegular,
  faAngleRight as faAngleRightRegular,
  faAngleLeft as faAngleLeftRegular,
  faAngleDown as faAngleDownRegular,
  faPrint as faPrintRegular,
  faFolder as faFolderRegular,
  faStopwatch as faStopwatchRegular,
  faPlus as faPlusRegular,
  faBookmark as faBookmarkRegular,
  faUpload as faUploadRegular,
  faDownload as faDownloadRegular,
  faCircleInfo as faCircleInfoRegular,
  faArrowRightFromBracket as faArrowRightFromBracketRegular,
  faPhotoFilmMusic as faPhotoFilmMusicRegular,
  faArrowUpRightDots as faArrowUpRightDotsRegular,
  faMasksTheater as faMasksTheaterRegular,
  faUserShakespeare as faUserShakespeareRegular,
  faClapperboardPlay as faClapperboardPlayRegular,
  faTag as faTagRegular,
  faPen as faPenRegular,
  faBarsProgress as faBarsProgressRegular,
  faLanguage as faLanguageRegular,
  faFile as faFileRegular,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faUser as faUserLight,
  faCheck as faCheckLight,
  faTimes as faTimesLight,
  faSearch as faSearchLight,
  faHeart as faHeartLight,
  faCheckCircle as faCheckCircleLight,
  faPhone as faPhoneLight,
  faEnvelope as faEnvelopeLight,
  faClock as faClockLight,
  faTicket as faTicketLight,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareLight,
  faArrowRight as faArrowRightLight,
  faArrowLeft as faArrowLeftLight,
  faCalendar as faCalendarLight,
  faUsers as faUsersLight,
  faBus as faBusLight,
  faViolin as faViolinLight,
  faLocationDot as faLocationDotLight,
  faFolder as faFolderLight,
  faUserShakespeare as faUserShakespeareLight,
  faSparkles as faSparklesLight,
} from '@fortawesome/pro-light-svg-icons'
 
import {
  faBookOpen as faBookOpenSolid,
  faUser as faUserSolid,
  faCheck as faCheckSolid,
  faTimes as faTimesSolid,
  faSearch as faSearchSolid,
  faHeart as faHeartSolid,
  faCheckCircle as faCheckCircleSolid,
  faPhone as faPhoneSolid,
  faEnvelope as faEnvelopeSolid,
  faClock as faClockSolid,
  faTicket as faTicketSolid,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareSolid,
  faArrowRight as faArrowRightSolid,
  faArrowLeft as faArrowLeftSolid,
  faFolder as faFolderSolid,
  faChevronDown as faChevronDownSolid,
  faBookmark as faBookmarkSolid,
  faArrowUpRightDots as faArrowUpRightDotsSolid,
  faArrowRightToBracket as faArrowRightToBracketSolid,
  faArrowRightFromBracket as faArrowRightFromBracketSolid,
  faPencil as faPencilSolid,
  faCircleInfo as faCircleInfoSolid,
  faLink as faLinkSolid,
  faSparkles as faSparklinesSolid,
  faInboxes as faInboxesSolid,
  faShare as faShareSolid,
  faFilter as faFilterSolid,
  faPlay as faPlaySolid,
  faEye as faEyeSolid,
  faEyeSlash as faEyeSlashSolid,
  faSchool as faSchoolSolid,
    faSpinner as faSpinnerSolid,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faPlay as faPlaySharp,
} from '@fortawesome/sharp-solid-svg-icons'

// Add all variants to the library
library.add(
  // Regular
  faMapMarkerAltRegular, faUserRegular, faCheckRegular, faTimesRegular, faSearchRegular,
  faHeartRegular, faCheckCircleRegular, faPhoneRegular, faEnvelopeRegular,
  faClockRegular, faTicketRegular, faArrowUpRightFromSquareRegular,
  faArrowRightRegular, faArrowLeftRegular, faAngleRightRegular, faAngleLeftRegular, faPrintRegular,
  faFolderRegular,faStopwatchRegular, faPlusRegular, faBookmarkRegular, faUploadRegular, faDownloadRegular,
  faCircleInfoRegular, faArrowRightToBracketRegular, faArrowRightFromBracketRegular, faPhotoFilmMusicRegular, faArrowUpRightDotsRegular, faMasksTheaterRegular,faUserShakespeareRegular,
  faClapperboardPlayRegular,faTagRegular,faPenRegular,faBarsProgressRegular,faLanguageRegular, faAngleDownRegular, faFileRegular,

  // Light
  faUserLight, faCheckLight, faTimesLight, faSearchLight,
  faHeartLight, faCheckCircleLight, faPhoneLight, faEnvelopeLight,
  faClockLight, faTicketLight, faArrowUpRightFromSquareLight,
  faArrowRightLight, faArrowLeftLight, faCalendarLight, faUsersLight, faBusLight, faViolinLight, faTicketLight,
  faLocationDotLight, faFolderLight, faUserShakespeareLight, faSparklesLight,

  // Solid
  faBookOpenSolid, faUserSolid, faCheckSolid, faTimesSolid, faSearchSolid,
  faHeartSolid, faCheckCircleSolid, faPhoneSolid, faEnvelopeSolid,
  faClockSolid, faTicketSolid, faArrowUpRightFromSquareSolid,
  faArrowRightSolid, faArrowLeftSolid, faFolderSolid,faChevronDownSolid, faBookmarkSolid, faArrowUpRightDotsSolid,
  faArrowRightToBracketSolid, faArrowRightFromBracketSolid, faPencilSolid, faCircleInfoSolid, faLinkSolid, faSparklinesSolid, 
  faInboxesSolid, faShareSolid, faFilterSolid, faPlaySolid, faEyeSolid, faEyeSlashSolid, faSchoolSolid, faSpinnerSolid,

  //Solid Sharp
  faPlaySharp,

)

dom.watch() // Replace <i> tags with <svg>
